import React from 'react';
import marked from 'marked';
import { HeadlineTitle } from '../../components/Title';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import Image from '../../components/Image';
import Button from '../../components/Button';
import { navRoutes } from '../../constants';
import * as S from './style';
import * as T from '../../components/Typography';
import composeStyle from '../../utils/composeStyle';

const Bold = composeStyle(T.H4SemiBold, 'H4SemiBold', 'P16Bold');

const OurStory = ({ title, subtitle, description }) => {
  return (
    <S.Wrapper>
      <SectionLayout bgcolor="gray2">
        <Row>
          <Col w={[4, 6, 4]}>
            <HeadlineTitle>{title}</HeadlineTitle>
          </Col>
          <Col w={[4, 6, 8]} mtT={4}>
            <S.TextsWrapper>
              <Bold color="midnight">{subtitle}</Bold>
              <T.P16 mt={3} color="gray1" as="pre">
                <div
                  dangerouslySetInnerHTML={{
                    __html: marked(description),
                  }}
                />
              </T.P16>
            </S.TextsWrapper>
            <Row mt={4} inner>
              <Col w={[4, 3, 6]}>
                <Button color="blue" small to={navRoutes.tempoStrategy} external caps={false}>
                  Read our strategy
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </SectionLayout>
      <S.ImageWrapper>
        <Image image="ctaStory" />
      </S.ImageWrapper>
    </S.Wrapper>
  );
};

export default OurStory;
